<template>
  <hic-dialog v-loading="meta.loading" :title="title" :visible="visible" @close="cancel" @open="open" width="60%"
    top="10vh">
    <el-main style="padding: 5px 20px">      
      <el-form class="left top-pad" ref="editInfo" :rules="rules" :inline="true" :model="editInfo" label-width="8rem">
        <el-row>
          <el-col :span="12">
            <el-form-item label="请选择患者：" prop="bedNo">
              <el-select v-model="editInfo.bedNo" value-key="id" placeholder="请选择患者" @change="handlePatientChange" clearable size="small" class="right-pad inputwidth" filterable>
                <el-option v-for="item in patientList" :key="item.id" :label="`${item.bedNo}：${item.patientName}`" :value="item.bedNo" style="height: 3rem">
                  <el-badge :value="item.news" :hidden="!item.news" style="margin: 0.5rem 0">
                    <el-tag size="small" :type="item.news > 0 ? 'danger' : 'info'" class="right-pad">{{ item.bedNo }}</el-tag>
                  </el-badge>

                  <b>{{ item.patientName }}</b>
                  <span>{{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="求医时间：" prop="seekTime">
              <el-date-picker size="small" v-model="editInfo.seekTime" type="datetime" placeholder="请选择" class="inputwidth"
                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="分组" prop="groupType">
              <hic-dict-selector dict-type="PatientGroup" is-enum v-model="editInfo.groupType"
                placeholder="请选择"></hic-dict-selector>
            </el-form-item>
          </el-col>


          <el-col :span="24">
            <el-form-item label="求医事项：" prop="seekMatter">
              <el-input type="textarea" v-model="editInfo.seekMatter" placeholder="请输入" size="small" style="width: 30vw;"
                :rows="4" clearable maxlength="50" :show-word-limit="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="巡诊记录：" prop="roundRecord">              
              <el-input type="textarea" v-model="editInfo.roundRecord" placeholder="请输入" size="small" style="width: 30vw;"
                :rows="4" clearable maxlength="50" :show-word-limit="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="处理：" prop="disposal">
              <el-input type="textarea" v-model="editInfo.disposal" placeholder="请输入" size="small" style="width: 30vw;"
                :rows="4" clearable maxlength="50" :show-word-limit="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </el-main>
    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="submit" class="left-pad">提交</el-button>
    </template>
  </hic-dialog>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  components: {},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },
    patientList: Array,
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      condition: {
        keyword: '',
      },
      detailValue: {},
      meta: {
        loading: false,
        showOper: false,
      },
      editInfo: {

      },
      rules: {
        bedNo: [{ required: true, message: '请选择患者', trigger: 'change' }],
        seekTime: [{ required: true, message: '请选择求医时间', trigger: 'change' }],        
        seekMatter: [{ required: true, message: '请输入求医事项', trigger: 'blur' }],        
        disposal: [{ required: true, message: '请输入处理措施', trigger: 'blur' }],
      },

    };
  },
  computed: {
    ...mapGetters(['dict', 'getDict', 'Enum', 'dictEnum', 'user', 'permission']),
  },
  filters: {},
  watch: {},
  mounted() { },
  methods: {
    open() {
      try {
        this.$refs['editInfo'].resetFields()
      } catch (error) {
      }

      this.$set(this, "editInfo", {})
      if (this.title.indexOf('新增') > -1) {
        // this.$set(this.editInfo, "execDate", this.$utils.Fmt.date(new Date()))
      } else {
        this.editInfo = this.$utils.Obj.clone(this.entity)
      }

    },
    handlePatientChange(val) {
      let findObj = this.patientList.find(el => el.bedNo == val)
      console.log(findObj)
      this.$set(this.editInfo, "ipNo", findObj.ipNo)
      this.$set(this.editInfo, "name", findObj.patientName)
      this.$set(this.editInfo, "groupType", findObj.groupType || "")
    },

    submit() {
      this.$refs['editInfo'].validate((valid) => {
        if (!valid) return
        this.meta.loading = true
        api.HospitalSeekMedical.save(this.editInfo)
          .then((res) => {
            this.$emit('ok')
            this.$message.success('提交成功')
            this.cancel()
          })
          .catch((err) => {
            this.$message.error(err || err.message);
          })
          .finally((f) => {
            this.meta.loading = false
          });
      })
    },

    cancel() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.inputwidth{
  width: 16rem;
}
.ztitle,
/deep/ .el-collapse-item__header {
  color: #66b1ff;
  font-size: 17px;
}
</style>
